import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr, localizedStatic } from "@/i18n/copy";
import { useEffect, useState } from "react";
import { QrCode, ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";

const ROLE_LABELS = localizedStatic({
  studio_owner: "Titolare",
  manager: "Agent · Manager",
  agent_marketing: "Agent · Marketing",
  artist: "Tatuatore",
  front_desk: "Reception",
}, [["studio_owner"],["manager"],["agent_marketing"],["artist"],["front_desk"]]);

export default function ProIdentityCard() {
  useUiLanguage();
  const [identity, setIdentity] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    let objectUrl;
    api.get("/pro-identity/me").then(setIdentity).catch(() => setIdentity(null));
    api.client.get("/pro-identity/me/qr/image", { responseType: "blob" })
      .then((response) => {
        objectUrl = URL.createObjectURL(response.data);
        setImageUrl(objectUrl);
      })
      .catch(() => setImageUrl(null));
    return () => { if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, []);

  if (!identity) return null;

  return <Card className="p-5 bg-card/60" data-testid="pro-identity-card">
    <div className="flex flex-col sm:flex-row gap-5 items-center sm:items-start">
      <div className="grid h-40 w-40 shrink-0 place-items-center rounded-2xl bg-white p-3">
        {imageUrl ? <img src={imageUrl} alt={tr("QR ID Pro")} className="h-full w-full object-contain" /> : <QrCode className="h-12 w-12 text-slate-700" />}
      </div>
      <div className="min-w-0 flex-1 text-center sm:text-left">
        <div className="label-tiny text-primary flex items-center justify-center sm:justify-start gap-2"><ShieldCheck className="h-4 w-4" />{tr("QR ID Pro")}</div>
        <h2 className="mt-2 font-display text-xl font-bold">{identity.name}</h2>
        <p className="mt-1 text-sm text-muted-foreground">{ROLE_LABELS[identity.role] || identity.role}</p>
        <p className="mt-4 text-sm text-muted-foreground">{tr("La tua identità professionale TPS. Il QR identifica il profilo, mentre permessi e accessi restano controllati dallo Studio.")}</p>
        {identity.artist_profile_id && <p className="mt-3 text-xs text-muted-foreground">{tr("Profilo artista:")} {identity.artist_profile_id}</p>}
      </div>
    </div>
  </Card>;
}

